const mandarin = {
  emergency: [
    { id: 'ma_em_1', e: 'Help!', t: '救命!', p: 'jyow-MING', pri: 'high' },
    { id: 'ma_em_2', e: 'Call the police.', t: '报警。', p: 'bow-JING', pri: 'high' },
    { id: 'ma_em_3', e: 'I need an ambulance.', t: '我需要救护车。', p: 'woh shoo-YOW jyow-HOO-chuh', pri: 'high' },
    { id: 'ma_em_4', e: 'I am hurt.', t: '我受伤了。', p: 'woh show-SHAHNG luh', pri: 'high' },
    { id: 'ma_em_5', e: 'I am lost.', t: '我迷路了。', p: 'woh MEE-loo luh', pri: 'high' },
    { id: 'ma_em_6', e: 'I need a hospital.', t: '我需要医院。', p: 'woh shoo-YOW ee-YWEN', pri: 'high' },
    { id: 'ma_em_7', e: 'I have an allergy.', t: '我过敏。', p: 'woh gwoh-MIN', pri: 'high' },
    { id: 'ma_em_8', e: 'I do not feel safe.', t: '我觉得不安全。', p: 'woh jweh-duh boo ahn-CHWEN', pri: 'high' },
    { id: 'ma_em_9', e: 'Please help me.', t: '请帮帮我。', p: 'ching bahng-bahng WOH', pri: 'high' },
    { id: 'ma_em_10', e: 'I need a doctor.', t: '我需要医生。', p: 'woh shoo-YOW ee-SHUNG', pri: 'high' },
  ],
  greetings: [
    { id: 'ma_gr_1', e: 'Hello', t: '你好', p: 'nee-HOW', pri: 'low' },
    { id: 'ma_gr_2', e: 'Good morning', t: '早上好', p: 'DZOW-shahng how', pri: 'low' },
    { id: 'ma_gr_3', e: 'Good evening', t: '晚上好', p: 'WAHN-shahng how', pri: 'low' },
    { id: 'ma_gr_4', e: 'Goodbye', t: '再见', p: 'dzai-JYEN', pri: 'low' },
    { id: 'ma_gr_5', e: 'Nice to meet you', t: '很高兴认识你', p: 'hen GOW-shing ren-shih NEE', pri: 'low' },
    { id: 'ma_gr_6', e: 'Thank you', t: '谢谢', p: 'syeh-SYEH', pri: 'low' },
    { id: 'ma_gr_7', e: 'Please', t: '请', p: 'ching', pri: 'low' },
    { id: 'ma_gr_8', e: 'Excuse me', t: '不好意思', p: 'boo-how EE-sih', pri: 'low' },
    { id: 'ma_gr_9', e: 'Sorry', t: '对不起', p: 'dway-boo-CHEE', pri: 'low' },
  ],
  basics: [
    { id: 'ma_ba_1', e: 'Yes', t: '是的', p: 'shih-DUH', pri: 'low' },
    { id: 'ma_ba_2', e: 'No', t: '不是', p: 'boo-SHIH', pri: 'low' },
    { id: 'ma_ba_3', e: 'Maybe', t: '也许', p: 'yeh-SHOO', pri: 'low' },
    { id: 'ma_ba_4', e: 'I don\'t understand', t: '我听不懂', p: 'woh TING boo DONG', pri: 'medium' },
    { id: 'ma_ba_5', e: 'Do you speak English?', t: '你会说英语吗？', p: 'nee hway SHWOH ying-YOO mah', pri: 'medium' },
    { id: 'ma_ba_6', e: 'Please write it down', t: '请写下来', p: 'ching SYEH syah-LIE', pri: 'medium' },
    { id: 'ma_ba_7', e: 'Can you repeat that?', t: '请再说一遍', p: 'ching DZAI shwoh ee-BYEN', pri: 'medium' },
    { id: 'ma_ba_8', e: 'Slowly please', t: '请慢点说', p: 'ching MAHN-dyen shwoh', pri: 'medium' },
  ],
  transportation: [
    { id: 'ma_tr_1', e: 'Where is the bus station?', t: '公交车站在哪里？', p: 'gong-jyow chuh-JAHN dzai NAH-lee', pri: 'medium' },
    { id: 'ma_tr_2', e: 'Where is the train station?', t: '火车站在哪里？', p: 'hwoh-CHUH jahn dzai NAH-lee', pri: 'medium' },
    { id: 'ma_tr_3', e: 'I need a taxi.', t: '我需要出租车。', p: 'woh shoo-YOW choo-dzoo-CHUH', pri: 'medium' },
    { id: 'ma_tr_4', e: 'Take me here.', t: '带我去这里。', p: 'dai woh CHOO juh-LEE', pri: 'medium' },
    { id: 'ma_tr_5', e: 'How much does this cost?', t: '这个多少钱？', p: 'juh-guh dwoh-SHOW chyen', pri: 'medium' },
    { id: 'ma_tr_6', e: 'Which direction?', t: '哪个方向？', p: 'NAH-guh fahng-SYAHNG', pri: 'medium' },
    { id: 'ma_tr_7', e: 'Where is the airport?', t: '机场在哪里？', p: 'jee-CHAHNG dzai NAH-lee', pri: 'medium' },
  ],
  hotel: [
    { id: 'ma_ho_1', e: 'I have a reservation.', t: '我有预订。', p: 'woh YOH yoo-DING', pri: 'medium' },
    { id: 'ma_ho_2', e: 'I need a room.', t: '我需要一个房间。', p: 'woh shoo-YOW ee-guh fahng-JYEN', pri: 'medium' },
    { id: 'ma_ho_3', e: 'Is breakfast included?', t: '包含早餐吗？', p: 'bow-HAHN dzow-TSAHN mah', pri: 'low' },
    { id: 'ma_ho_4', e: 'What time is checkout?', t: '几点退房？', p: 'jee-DYEN tway-FAHNG', pri: 'low' },
    { id: 'ma_ho_5', e: 'The room is dirty.', t: '房间很脏。', p: 'fahng-JYEN hen DZAHNG', pri: 'low' },
    { id: 'ma_ho_6', e: 'The AC is not working.', t: '空调坏了。', p: 'kong-TYOW hwai-LUH', pri: 'low' },
  ],
  food: [
    { id: 'ma_fo_1', e: 'I would like this.', t: '我想要这个。', p: 'woh syahng-YOW juh-GUH', pri: 'low' },
    { id: 'ma_fo_2', e: 'Water please.', t: '请给我水。', p: 'ching GAY woh SHWAY', pri: 'low' },
    { id: 'ma_fo_3', e: 'One beer please.', t: '一杯啤酒。', p: 'ee-BAY pee-JYOH', pri: 'low' },
    { id: 'ma_fo_4', e: 'No meat.', t: '不要肉。', p: 'boo-YOW roh', pri: 'medium' },
    { id: 'ma_fo_5', e: 'I am allergic to peanuts.', t: '我对花生过敏。', p: 'woh dway hwah-SHUNG gwoh-MIN', pri: 'high' },
    { id: 'ma_fo_6', e: 'Is this spicy?', t: '这个辣吗？', p: 'juh-guh LAH mah', pri: 'low' },
    { id: 'ma_fo_7', e: 'The bill please.', t: '买单。', p: 'mai-DAHN', pri: 'low' },
  ],
  bathroom: [
    { id: 'ma_bt_1', e: 'Where is the bathroom?', t: '洗手间在哪里？', p: 'shee-SHOW-jyen dzai NAH-lee', pri: 'medium' },
    { id: 'ma_bt_2', e: 'Is there toilet paper?', t: '有卫生纸吗？', p: 'yoh way-SHUNG-jih mah', pri: 'low' },
    { id: 'ma_bt_3', e: 'I need a shower.', t: '我需要洗澡。', p: 'woh shoo-YOW shee-DZOW', pri: 'low' },
    { id: 'ma_bt_4', e: 'Is there hot water?', t: '有热水吗？', p: 'yoh ruh-SHWAY mah', pri: 'low' },
  ],
  shopping: [
    { id: 'ma_sh_1', e: 'How much is this?', t: '这个多少钱？', p: 'juh-guh dwoh-SHOW chyen', pri: 'medium' },
    { id: 'ma_sh_2', e: 'Too expensive.', t: '太贵了。', p: 'tai GWAY luh', pri: 'low' },
    { id: 'ma_sh_3', e: 'Can you lower the price?', t: '能便宜点吗？', p: 'nung pyen-YEE dyen mah', pri: 'low' },
    { id: 'ma_sh_4', e: 'Do you take cards?', t: '能刷卡吗？', p: 'nung SHWAH-kah mah', pri: 'medium' },
    { id: 'ma_sh_5', e: 'Where is the ATM?', t: 'ATM在哪里？', p: 'ATM dzai NAH-lee', pri: 'medium' },
    { id: 'ma_sh_6', e: 'I need cash.', t: '我需要现金。', p: 'woh shoo-YOW syen-JIN', pri: 'medium' },
  ],
  health: [
    { id: 'ma_he_1', e: 'I need medicine.', t: '我需要药。', p: 'woh shoo-YOW yow', pri: 'high' },
    { id: 'ma_he_2', e: 'I have a fever.', t: '我发烧了。', p: 'woh fah-SHOW luh', pri: 'high' },
    { id: 'ma_he_3', e: 'I feel sick.', t: '我不舒服。', p: 'woh boo SHOO-foo', pri: 'high' },
    { id: 'ma_he_4', e: 'My stomach hurts.', t: '我肚子疼。', p: 'woh DOO-dzih tung', pri: 'medium' },
    { id: 'ma_he_5', e: 'I need a pharmacy.', t: '我需要药店。', p: 'woh shoo-YOW yow-DYEN', pri: 'medium' },
    { id: 'ma_he_6', e: 'I need pain medicine.', t: '我需要止痛药。', p: 'woh shoo-YOW jih-TONG yow', pri: 'medium' },
  ],
  police: [
    { id: 'ma_po_1', e: 'I lost my passport.', t: '我的护照丢了。', p: 'woh-duh hoo-DJOW dyoh-LUH', pri: 'high' },
    { id: 'ma_po_2', e: 'Someone stole my bag.', t: '有人偷了我的包。', p: 'yoh-REN toh-luh woh-duh BOW', pri: 'high' },
    { id: 'ma_po_3', e: 'I need help.', t: '我需要帮助。', p: 'woh shoo-YOW bahng-JOO', pri: 'high' },
    { id: 'ma_po_4', e: 'Please call the embassy.', t: '请联系大使馆。', p: 'ching lyen-SHEE dah-shih-GWAHN', pri: 'high' },
    { id: 'ma_po_5', e: 'I need the police.', t: '我需要警察。', p: 'woh shoo-YOW jing-CHAH', pri: 'high' },
  ],
  airport: [
    { id: 'ma_ai_1', e: 'Where is customs?', t: '海关在哪里？', p: 'hai-GWAHN dzai NAH-lee', pri: 'medium' },
    { id: 'ma_ai_2', e: 'Where is baggage claim?', t: '行李提取在哪里？', p: 'sing-LEE tee-CHOO dzai NAH-lee', pri: 'medium' },
    { id: 'ma_ai_3', e: 'I am here for tourism.', t: '我来旅游的。', p: 'woh LAI loo-YOH duh', pri: 'medium' },
    { id: 'ma_ai_4', e: 'Here is my passport.', t: '这是我的护照。', p: 'juh-SHIH woh-duh hoo-DJOW', pri: 'medium' },
    { id: 'ma_ai_5', e: 'Where is my gate?', t: '我的登机口在哪里？', p: 'woh-duh dung-JEE-koh dzai NAH-lee', pri: 'medium' },
  ],
  phone: [
    { id: 'ma_ph_1', e: 'Do you have Wi-Fi?', t: '有Wi-Fi吗？', p: 'yoh WAI-fai mah', pri: 'low' },
    { id: 'ma_ph_2', e: 'What is the password?', t: '密码是什么？', p: 'mee-MAH shih shen-MUH', pri: 'low' },
    { id: 'ma_ph_3', e: 'My phone is dead.', t: '我手机没电了。', p: 'woh show-JEE may-DYEN luh', pri: 'medium' },
    { id: 'ma_ph_4', e: 'Where can I charge my phone?', t: '哪里可以充电？', p: 'NAH-lee kuh-YEE chong-DYEN', pri: 'low' },
    { id: 'ma_ph_5', e: 'I need internet.', t: '我需要网络。', p: 'woh shoo-YOW wahng-LWOH', pri: 'low' },
  ],
  nightlife: [
    { id: 'ma_ni_1', e: 'Cheers!', t: '干杯!', p: 'gahn-BAY', pri: 'low' },
    { id: 'ma_ni_2', e: 'Another drink please.', t: '再来一杯。', p: 'dzai-LAI ee-BAY', pri: 'low' },
    { id: 'ma_ni_3', e: 'Where is a good bar?', t: '哪里有好的酒吧？', p: 'NAH-lee yoh how-duh jyoh-BAH', pri: 'low' },
    { id: 'ma_ni_4', e: 'I am here with friends.', t: '我和朋友一起来的。', p: 'woh HUH pung-YOH ee-CHEE lai-DUH', pri: 'low' },
    { id: 'ma_ni_5', e: 'I need a ride home.', t: '我需要回家的车。', p: 'woh shoo-YOW hway-JYAH duh CHUH', pri: 'medium' },
    { id: 'ma_ni_6', e: 'Please leave me alone.', t: '请别打扰我。', p: 'ching byeh DAH-row woh', pri: 'medium' },
  ],
  fitness: [
    { id: 'ma_fi_1', e: 'Where is the gym?', t: '健身房在哪里？', p: 'jyen-SHIN-fahng dzai NAH-lee', pri: 'low' },
    { id: 'ma_fi_2', e: 'How much is a day pass?', t: '日卡多少钱？', p: 'rih-KAH dwoh-SHOW chyen', pri: 'low' },
    { id: 'ma_fi_3', e: 'Do you have showers?', t: '有淋浴吗？', p: 'yoh lin-YOO mah', pri: 'low' },
    { id: 'ma_fi_4', e: 'I need water.', t: '我需要水。', p: 'woh shoo-YOW SHWAY', pri: 'low' },
    { id: 'ma_fi_5', e: 'What time do you close?', t: '几点关门？', p: 'jee-DYEN gwahn-MEN', pri: 'low' },
  ],
  respectful: [
    { id: 'ma_re_1', e: 'Thank you for your help.', t: '谢谢你的帮助。', p: 'syeh-SYEH nee-duh bahng-JOO', pri: 'low' },
    { id: 'ma_re_2', e: 'Your country is beautiful.', t: '你的国家很美。', p: 'nee-duh gwoh-JYAH hen MAY', pri: 'low' },
    { id: 'ma_re_3', e: 'I appreciate it.', t: '我很感激。', p: 'woh hen GAHN-jee', pri: 'low' },
    { id: 'ma_re_4', e: 'I am visiting from America.', t: '我从美国来旅游。', p: 'woh tsong may-GWOH lai loo-YOH', pri: 'low' },
    { id: 'ma_re_5', e: 'Have a nice day.', t: '祝你愉快。', p: 'joo nee yoo-KWAI', pri: 'low' },
  ],
};
export default mandarin;
